import React, { useEffect, useMemo, useRef, useState } from "react";
import styles from '../../../Components/DropDownSelect/Dropdown.module.css';
import { useDispatch, useSelector } from '../../../redux/store';
import { fetchTeamOptions } from '../../../redux/slices/options';

function EmpInfoTeamFilter(props) {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState('All'); // Initialize with 'All'
  const dropdownRef = useRef(null);
  const dispatch = useDispatch();
  const { teamOptions } = useSelector((s) => s.options);

  const handleSelect = (event) => {
    props.onSelect(event.target.value);
  };

  const toggleDropdown = () => {
    if (!props.disabled) {
      setIsOpen(!isOpen);
    }
  };

  const selectOption = (option) => {
    setSelectedOption(option.name);
    setIsOpen(false);
    handleSelect({ target: { value: option.value } });
  };

  useEffect(() => {
    const promise = dispatch(fetchTeamOptions());
    return () => {
      promise?.abort?.();
    };
  }, [dispatch]);

  const dropdownOptions = useMemo(() => {
    const transformedData = (Array.isArray(teamOptions) ? teamOptions : []).map((team) => ({
      name: team,
      value: (team || '').toString().toUpperCase(),
    }));

    transformedData.unshift({ name: 'Fields', value: 'FIELDS' });
    transformedData.unshift({ name: 'All', value: '' });

    transformedData.sort((a, b) => a.name.localeCompare(b.name));
    return transformedData;
  }, [teamOptions]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!props.disabled && dropdownRef.current && !dropdownRef.current.contains(event.target) && isOpen) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, props.disabled]);

  return (
    <div className={`${styles.dropdown} ${props.disabled ? styles.dropdownDisabled : ''}`} ref={dropdownRef}>
      <div className={styles.dropdownSelected} onClick={toggleDropdown}>
        {selectedOption}
      </div>
      {isOpen && (
        <div className={styles.dropdownOptions}>
          {dropdownOptions.map((team) => (
            <div key={team.value} className={styles.dropdownOption} onClick={() => selectOption(team)}>
              {team.name}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default EmpInfoTeamFilter;